import { customTransactionsSapInventory } from "integration/generated/customTransactions";
import { RequestParams } from "integration/generated/customTransactions/http-client";
import { GetServerSidePropsContext } from "next";
import { error as logError } from '@/data/utils/loggerUtil';
import useSWR from "swr";
import { EMPTY_STRING } from "@/data/constants/marketing";
import { useSettings } from "@/data/Settings";
import { useEffect, useState } from "react";
import { StoreStockSapInventory } from "integration/generated/customTransactions/data-contracts";

const DATA_KEY = 'SAP_STORE_STOCK';
const DATA_KEY_INSTORE = 'SAP_STORE_STOCK_INSTORE';

export const sapInventoryCheckFetcher =
	(pub: boolean, context?: GetServerSidePropsContext) =>
		async (
			storeId: string,
			orderId:string,
			query: {
				source: string;
				physicalStoreId: string;
			}
		) => {
			return await customTransactionsSapInventory(pub).sapInventoryAvailabilityCheckInventoryByOrderIdDetail(
				storeId,
				orderId,
				query,
				{}
			);
		};

const fetcher =
	(pub: boolean, context?: GetServerSidePropsContext) =>
	async (
		storeId: string,
		query: {
			storeNumber: string;
			partNumber: string;
			[key:string]:string | boolean | undefined | string[]
		},
		params: RequestParams
	) => {
		try {
			const data = await customTransactionsSapInventory(pub).sapInventoryAvailabilityGetStoreInventoryByStoreNumbersAndPartNumberDetail(
				storeId,
				query,
				params
			);
			return data;
		} catch (error:any) {
			logError(context?.req, 'StoreLocator: fetcher: error: %o', error);
			return {
				status:error?.status 
			} as StoreStockSapInventory
		}
	};

	const rawStorestockFetcher =
	(pub: boolean, context?: GetServerSidePropsContext) =>
	async (
		storeId: string,
		query: {
			storeNumber: string;
			partNumber: string;
			[key:string]:string | boolean | undefined | string[]
		},
		params: RequestParams
	) => {
		try {
			const data = await customTransactionsSapInventory(pub).sapInventoryAvailabilityGetStoreStockByStoreNumbersAndPartNumberDetail(
				storeId,
				query,
				params
			);
			return data;
		} catch (error) {
			logError(context?.req, 'rawStorestockFetcher: fetcher: error: %o', error);
		}
	};

export const useSapStoreStock = (storeNumber: string, partNumber: string, hasLimit?:boolean) => {
	const {settings} = useSettings();
	const [isSapStockStatusAvailable, setSapStockStatusAvailable] = useState(true);
	const { data, isLoading } = useSWR(
		storeNumber && storeNumber!==EMPTY_STRING && partNumber?.length>0
				? [
						{
							storeId: settings?.storeId,
							query: {
								storeNumber,
								partNumber,
								hasLimit,
								isOrder:true
							},
						},
						DATA_KEY,
				  ]
				: null,
			async ([props]) => fetcher(true)(props.storeId, props.query, {}));
	
	useEffect(()=>{
		if(data && (data.status===500 || data.status===503)){
			setSapStockStatusAvailable(false);
		}
	},[data]);

	return {
		sapStoreStock:data,
		isLoading,
		isSapStockStatusAvailable,
		setSapStockStatusAvailable
	}
}

	
export const useSapStoreInternalStock = (storeNumber: string, partNumber: string, hasLimit?:boolean) => {
	const {settings} = useSettings();
	const { data, isLoading } = useSWR(
		storeNumber && storeNumber!==EMPTY_STRING
				? [
						{
							storeId: settings?.storeId,
							query: {
								storeNumber,
								partNumber,
								hasLimit,
								isOrder:true
							},
						},
						DATA_KEY_INSTORE,
				  ]
				: null,
			async ([props]) => rawStorestockFetcher(true)(props.storeId, props.query, {}));
		return {
			sapStoreStock:data, isLoading
		}
	}

